import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import AdminForm from "../components/admin/formadmin";
import "../style/pages.css";
import Project from "./project";
import Files from "./files";
import { handleDelete } from "../utils/fireStoreFunction";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, database } from "../utils/fipresConfig";
import { doc, getDoc } from "firebase/firestore";
import Notes from "./notes";

export default function Admin({ editData }) {
  const [formEditData, setFormEditData] = useState(null);
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [user] = useAuthState(auth);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (editData) {
      setFormEditData(editData);
    }
  }, [editData]);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user) {
        const docRef = doc(database, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const userData = docSnap.data();
          if (userData.isAdmin === true) {
            setIsAuthorized(true);
          } else {
            setIsAuthorized(false);
            setMessage("You do not have permission to view this page.");
            navigate("/");
          }
        } else {
          setIsAuthorized(false);
          setMessage("User data not found.");
          navigate("/");
        }
      }
    };

    fetchUserRole();
  }, [user, navigate]);

  const handleEditClick = (data) => {
    setFormEditData(data);
    document.getElementById("admin-form").scrollIntoView({ behavior: "smooth" });
  };

  const handleDeleteClick = async (id) => {
    const result = await handleDelete(id);
    if (result.success) {
      setMessage("Document successfully deleted!");
    } else {
      setMessage(`Error deleting document: ${result.error}`);
    }
  };

  if (!isAuthorized) {
    return <p>{message}</p>;
  }

  return (
    <div className="admin-container">
      <div id="admin-form" >
        <AdminForm editData={formEditData} />
      </div>
      <div>
        <Project onEditClick={handleEditClick} onDeleteClick={handleDeleteClick} />
        <Files onEditClick={handleEditClick} onDeleteClick={handleDeleteClick} />
      </div>
      <div className="notes">
        <Notes isAdminView={true} />
      </div>
      {message && <p className="massage_alert">{message}</p>}
    </div>
  );
}